import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_DESTINATION].GET_REPORTS_FINANCE_BY_DESTINATION]: {
		url: '/company/:companyId/reports/finance/by_destination/',
	},
}
